module.exports = __webpack_public_path__ + "img/cat.3fb6b1e5.png";